import React, { FunctionComponent } from 'react';
import { View } from 'react-native';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { ViewStyle, StyleProp } from 'react-native';

export interface LottieWrapperProps {
  source: any;
  autoPlay?: boolean;
  loop?: boolean;
  style?: StyleProp<ViewStyle>;
}

export const LottieWrapper: FunctionComponent<LottieWrapperProps> = ({
  source,
  autoPlay = true,
  loop = true,
  style,
}) => {
  // Extraire width et height du style si disponible
  const flatStyle = style as ViewStyle | undefined;
  const width = flatStyle?.width || 150;
  const height = flatStyle?.height || 150;

  return (
    <View style={[{ width, height }, style]}>
      <DotLottieReact
        data={source}
        autoplay={autoPlay}
        loop={loop}
        style={{ width: '100%', height: '100%' }}
      />
    </View>
  );
};
